import { useParams } from 'react-router-dom'
import Page from '../../components/layouts/page'
import { useQuery } from '@tanstack/react-query'
import isEmpty from '../../helpers/is_empty'
import Snapshots from './snapshots'
import GenerateSnapshotButton from './generate_snapshot_button'

const Publishing = () => {
  const { cycleID } = useParams()
  const { data: cycle, error, isLoading } = useQuery(['cycles/', cycleID])
  const snapshotsQueryKey = [`snapshots?cycle_id=${cycleID}`]

  return (
    <Page
      title='Submission'
      pending={isLoading}
      error={error || isEmpty(cycle)}
      buttons={[
        <GenerateSnapshotButton
          key='generate-snapshot'
          cycleID={cycleID}
          hasErrors={cycle?.has_errors}
          queryKey={snapshotsQueryKey}
        />,
      ]}
    >
      <Snapshots queryKey={snapshotsQueryKey} cycle={cycle} />
    </Page>
  )
}

export default Publishing
